var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.861,
    height: 36.75,
    viewBox: "0 0 163.861 36.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-517.529 -1158.11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M536.052,1187.343l-1.652-5.761h-7.831l-1.755,5.761h-7.285l9.025-29.233h9.487l9.168,29.233Zm-7.958-12.143h4.729l-2.365-8.48Z",
    transform: "translate(0 0)",
    fill: "#ed4225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M641.049,1204.669h-8.138a14.429,14.429,0,0,1-.3-3.041,7.829,7.829,0,0,1-7,3.491q-3.855,0-5.772-1.97a6.3,6.3,0,0,1-1.917-4.519,6.476,6.476,0,0,1,3.137-5.578q3.137-2.131,11.126-2.559V1190a2.24,2.24,0,0,0-.653-1.906,3.262,3.262,0,0,0-1.917-.471q-2.955,0-3.3,2.377l-7.8-.728q1.671-6.831,11.372-6.832a20.925,20.925,0,0,1,4.84.525,8.118,8.118,0,0,1,3.491,1.638,5.687,5.687,0,0,1,1.724,2.356,16.9,16.9,0,0,1,.439,4.775v8.695A12.011,12.011,0,0,0,641.049,1204.669Zm-8.866-10.194q-5.461.579-5.461,3.491,0,1.971,2.163,1.97a3.5,3.5,0,0,0,2.334-.814q.964-.814.964-3.6Z",
    transform: "translate(-71.496 -17.327)",
    fill: "#ed4225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M719.789,1158.11v29.233h-8.416V1158.11Z",
    transform: "translate(-138.05 0)",
    fill: "#ed4225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M770.648,1184l-8.545,23.6a9.513,9.513,0,0,1-2.827,4.187q-1.842,1.51-5.675,1.51-.921,0-4.283-.193v-6.061a20.378,20.378,0,0,0,3.084.257q3.684,0,3.684-1.628a4.443,4.443,0,0,0-.364-1.478L747.9,1184h9.14l3.6,11.622,3.76-11.622Z",
    transform: "translate(-164.068 -18.44)",
    fill: "#ed4225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M850.736,1204.669H842.6a14.45,14.45,0,0,1-.3-3.041,7.829,7.829,0,0,1-7,3.491q-3.854,0-5.771-1.97a6.3,6.3,0,0,1-1.917-4.519,6.477,6.477,0,0,1,3.137-5.578q3.137-2.131,11.126-2.559V1190a2.24,2.24,0,0,0-.653-1.906,3.262,3.262,0,0,0-1.917-.471q-2.955,0-3.3,2.377l-7.8-.728q1.671-6.831,11.372-6.832a20.926,20.926,0,0,1,4.84.525,8.118,8.118,0,0,1,3.491,1.638,5.687,5.687,0,0,1,1.724,2.356,16.9,16.9,0,0,1,.439,4.775v8.695A12.018,12.018,0,0,0,850.736,1204.669Zm-8.866-10.194q-5.461.579-5.461,3.491,0,1.971,2.163,1.97a3.5,3.5,0,0,0,2.334-.814q.963-.814.964-3.6Z",
    transform: "translate(-220.829 -17.327)",
    fill: "#ed4225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M942.325,1204.669h-8.545v-13.706a3.044,3.044,0,0,0-.524-2.163,1.9,1.9,0,0,0-1.317-.471q-2.334,0-2.334,3.255v13.085H921.06v-21.78h7.923v3.084q1.756-3.534,6.275-3.534a8.168,8.168,0,0,1,4.016.91,5.442,5.442,0,0,1,2.345,2.355,12.529,12.529,0,0,1,.707,5.022Z",
    transform: "translate(-287.384 -17.327)",
    fill: "#ed4225"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M1029.606,1204.669h-8.138a14.433,14.433,0,0,1-.3-3.041,7.828,7.828,0,0,1-7,3.491q-3.855,0-5.771-1.97a6.3,6.3,0,0,1-1.917-4.519,6.477,6.477,0,0,1,3.137-5.578q3.138-2.131,11.126-2.559V1190a2.24,2.24,0,0,0-.653-1.906,3.261,3.261,0,0,0-1.916-.471q-2.956,0-3.3,2.377l-7.8-.728q1.671-6.831,11.372-6.832a20.923,20.923,0,0,1,4.84.525,8.117,8.117,0,0,1,3.491,1.638,5.688,5.688,0,0,1,1.724,2.356,16.908,16.908,0,0,1,.439,4.775v8.695A12.012,12.012,0,0,0,1029.606,1204.669Zm-8.866-10.194q-5.461.579-5.461,3.491,0,1.971,2.163,1.97a3.5,3.5,0,0,0,2.334-.814q.964-.814.964-3.6Z",
    transform: "translate(-348.216 -17.327)",
    fill: "#ed4225"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.03c90cd033bc4c3e85a0644fa89d1ac6.svg";
export { ForwardRef as ReactComponent };